import { useState } from 'react';
import { useQueryParamsState } from '../../hooks/useQueryParamsState';
import { PAGINATION_SIZE_OPTIONS } from '../../core/pagination';
import { ColumnBoxFlexFullWidth } from '../common/boxes';
import { Loader } from '../common/Loader';
import { IClientAdminSearchParams } from '../../interfaces/clientAdminSearchParams';
import ClientsTableWithSearch from './ClientsTableWithSearch';
import { Box } from '@mui/material';
import CreateClient from './CreateClient';
import { useGetClientsList } from '../../queryHooks/client/useGetClientsList';
import { ISearchHeaderInputProps } from '../../interfaces/searchHeaderProps';
import { getStateFromSearchInputProps } from '../../utils/getStateFromSearchInputProps';

const searchInputProps: ISearchHeaderInputProps[] = [
  { name: 'id', label: 'ID', sx: { width: 100 }, isNumber: true },
  { name: 'email', label: 'Email' },
  { name: 'legalName', label: 'Legal Name' },
  { name: 'contactName', label: 'Contact Name' },
  { name: 'phone', label: 'Phone' },
  {
    name: 'registered', label: 'Registered', select: {
      list: ['true', 'false'],
      getValue: (v) => v,
      getLabel: (v) => v
    }, sx: { minWidth: 120 }
  },
  { name: 'fromDate', label: 'From Date', isDatePicker: true },
  { name: 'toDate', label: 'To Date', isDatePicker: true }
];

export const clientsInitialState: IClientAdminSearchParams = getStateFromSearchInputProps<IClientAdminSearchParams>(searchInputProps);
export const CLIENT_LIST_QUERY_KEY = 'clients';

const Clients = () => {
  const [searchState, setSearchState] = useState<IClientAdminSearchParams>(clientsInitialState);
  const [totalCount, setTotalCount] = useState(0);
  const { queryParamState, isPrePopulated } = useQueryParamsState({
    state: searchState,
    setState: setSearchState,
    wildcards: ['legalName', 'contactName', 'email', 'phone'],
    parser: { size: (val: string) => PAGINATION_SIZE_OPTIONS.includes(+val) ? +val : PAGINATION_SIZE_OPTIONS[0] }
  });
  const { data, isLoading } = useGetClientsList({
    search: queryParamState,
    enabled: !!Object.keys(queryParamState).length,
    onSuccess: ((data) => setTotalCount(data.size * data.totalPages - (data.size - data.totalElements))),
  });

  return (
    <ColumnBoxFlexFullWidth>
      <Box mb={{ mobile: 3.5, tablet: 2 }} alignSelf={{ mobile: 'center', tablet: 'flex-end' }}>
        <CreateClient/>
      </Box>
      {
        isLoading && <Loader/>
      }
      {
        data &&
        <ColumnBoxFlexFullWidth>
          {
            isPrePopulated &&
            <ClientsTableWithSearch
              searchInputProps={searchInputProps}
              searchProps={{
                params: searchState,
                setParams: setSearchState,
                initialState: clientsInitialState
              }}
              tableData={{
                list: data.content,
                pagination: {
                  size: searchState.size,
                  page: searchState.page,
                  setState: setSearchState,
                  sizeOptions: PAGINATION_SIZE_OPTIONS,
                  totalCount: totalCount
                }
              }}
            />
          }
        </ColumnBoxFlexFullWidth>
      }
    </ColumnBoxFlexFullWidth>
  );
};

export default Clients;